"use client";

import React, { useContext, useEffect, useState } from "react";
import { useLayout } from "@/lib/context/layout";

interface AvatarProps {
    name?: string;
    size?: number;
    avatar?: string;
}

const generateColor = (name: string): [string, string] => {
    let hash = 0;
    let i: number;
    const rgb = [0, 0, 0];
    for (i = 0; i < name.length; i += 1) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "";
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        rgb[i] = value;
        color += `00${value.toString(16)}`.slice(-2);
    }
    const [r, g, b] = rgb;
    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    return ["#" + color, hsp > 127.5 ? "black" : "white"];
};

export const AvatarElement = (props: AvatarProps) => {
    const { userState } = useLayout();
    const [state, setState] = useState({
        name: props.name || "Loading",
        avatar: props.avatar,
        size: props.size || 2.4,
    });

    useEffect(() => {
        setState({
            name: userState.name || "Loading",
            avatar: userState.avatar,
            size: props.size || 2.4,
        });
    }, [userState]);

    const [color, text_color] = generateColor(state.name || "Loading");
    const size = state.size;

    if (!state.avatar) {
        return (
            <div
                className="flex items-center justify-center rounded-full"
                style={{
                    backgroundColor: color,
                    color: text_color,
                    width: `${size}rem`,
                    height: `${size}rem`,
                    fontSize: `${size / 2}rem`,
                    fontWeight: "normal",
                    flexShrink: 0,
                }}
            >
                {state.name
                    ?.split(" ")
                    .map((n) => n[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase()}
            </div>
        );
    }
    return (
        <img
            alt="avatar"
            src={state.avatar}
            className="flex items-center justify-center"
            style={{
                borderRadius: "50%",
                width: `${size}rem`,
                height: `${size}rem`,
            }}
        />
    );
};
